import { deleteRequest, get, post, postWithoutToken } from '@/apis/auth-client';

const postContentEngagementDetail = async (
  slug: string,
  content_type: string,
  favorite_type: string,
  title?: string,
  isFollowed?: boolean,
) => {
  try {
    let payload = {};
    if (favorite_type === 'favorite' || favorite_type === 'like') {
      payload = {
        content_type: content_type,
        content_slug: slug,
        favorite_type: favorite_type,
      };
    } else if (favorite_type === 'following') {
      payload = {
        performDelete: isFollowed,
        items: [
          {
            content_type: content_type,
            content_slug: slug,
            favorite_type: 'follow',
            content_title: title,
          },
        ],
      };
    }
    const postRes = await post(favorite_type === 'favorite' ? 'save' : favorite_type, payload);

    return postRes;
  } catch (error) {
    console.error(`Failed to POST engagement count for ${slug} from /${favorite_type}`, error);
    throw error;
  }
};

const deleteContentEngagementDetail = async (
  slug: string,
  content_type: string,
  favorite_type: string,
) => {
  try {
    const delRes = await deleteRequest(`save?content_slug=${encodeURIComponent(slug)}`);
    // console.log('api call happening', data);
    return delRes;
  } catch (error) {
    console.error(`Failed to DELETE engagement detail for ${slug} from /save`, error);
    throw error;
  }
};

const getContentEngagementStatus = async (slug: string) => {
  try {
    const data = await get(`like/status?content_url=${slug}`);
    return data;
  } catch (error) {
    console.error(`Failed to GET like status for ${slug} from /like/status`, error);
    throw error;
  }
};

const postContentFeedback = async (
  slug: string,
  content_type: string,
  action: 'like' | 'dislike',
) => {
  try {
    const payload = {
      content_type: content_type,
      slug: slug,
      action: action, 
    };

    const postRes = await postWithoutToken('feedback', payload);
    
    if (!postRes) {
      throw new Error('Failed to post feedback - no response received');
    }
    
    return postRes;
  } catch (error) {
    console.error(`Failed to POST feedback (${action}) for ${slug}`, error);
    throw error;
  }
};

export {
  postContentEngagementDetail,
  deleteContentEngagementDetail,
  getContentEngagementStatus,
  postContentFeedback,
};
